"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { DraggableAttributes } from "@dnd-kit/core";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";

export type SortableRowHandleValue = {
  setActivatorNodeRef: (element: HTMLElement | null) => void;
  listeners: SyntheticListenerMap | undefined;
  attributes: DraggableAttributes;
  isDragging: boolean;
};

const SortableRowHandleContext = createContext<SortableRowHandleValue | null>(
  null,
);

export function SortableRowHandleProvider({
  value,
  children,
}: {
  value: SortableRowHandleValue;
  children: ReactNode;
}) {
  return (
    <SortableRowHandleContext.Provider value={value}>
      {children}
    </SortableRowHandleContext.Provider>
  );
}

export function useSortableRowHandle() {
  return useContext(SortableRowHandleContext);
}
